export const array_ = (list) => {
    return list instanceof Array? list: [];
}